import React from 'react'
import ReactECharts from 'echarts-for-react';
import { ReportViewModel } from '../../model/ReportViewModel'
import styled from 'styled-components';

interface IProps {
    view:ReportViewModel
}


const Section = styled.section`

em {
    font-weight:bold;
}

`;

const ComparativeTradingActivityPage:React.FC<IProps> = (props:IProps)=>{
    
    const { view } = props;
    const items = view.comparativeTradingActivity.items;
    const options = {
        title: {
            text: `Period: (${view.startDate} - ${view.endDate})`,
            left: 'center',
            textStyle: { fontSize: 12, fontWeight: 'normal', color: '#666' }
        },
        tooltip: {
            trigger: 'item',
            formatter: (p:any) => {
                const item = items[p.dataIndex];
                const meta = p.seriesName === view.ticker ? [ item.meta[0] ] : item.meta.slice(1);
                return `<div>${p.value}% traded via ${p.name}</div>` + meta.map((x:any) => `<br/><b>${x.ticker}</b>: ${x.value.toLocaleString()}`).join('');
            }
        },
        legend: { orient: 'vertical', right: 40, top: 80, borderColor: '#ccc', borderWidth: 1, backgroundColor: '#fff', shadowBlur: 6, shadowColor: 'rgba(0,0,0,0.3)' },
        grid: { left: 10, right: 40, top: 40, bottom: 30, containLabel: true },
        xAxis: { type: 'value', min: 0, axisLabel: { formatter: '{value}%' } },
        yAxis: { type: 'category', data: items.map(x=>x.name), inverse: true, axisLabel: { interval: 0 } },
        series: [{
            name: view.ticker,
            type: 'bar',
            barWidth: 15,
            data: items.map(x=>Math.round(x.target)),
        }, {
            name: 'Peers',
            type: 'bar',
            barWidth: 15,
            data: items.map(x=>Math.round(x.peers)),
        }]
    }
    
    return <Section>
        <h2>Comparative Trading Activity</h2>
        <p>Total Value Traded: ({view.ticker}): <em>${view.comparativeTradingActivity.targetValue.toLocaleString()}</em> </p>
        <p>Total Value Traded: (Peers, {view.peers.join(',')}): <em>${view.comparativeTradingActivity.totalPeerValue.toLocaleString()}</em> </p>

        <ReactECharts option={options} notMerge={true} style={{ height: items.length * 50 + 70 }} />

    </Section>
    
}

export default ComparativeTradingActivityPage;
